// Holding dashboard — replaced by the design-studio "DefaultMenuItem" page once
// the corresponding use case is implemented. Currently DEFAULT_ROUTE resolves
// to the Pull Order Entry & Status Page (pageId 72447), so this page is only
// hit if a user navigates directly to /dashboard before that page is wired in.
import { Link } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext.jsx';
import { MENU_TREE } from '../utils/menuConfig.js';

export default function DefaultPage() {
  const { user, roles } = useAuth();
  return (
    <div className="container-fluid px-4 py-4" data-testid="default-page">
      <div className="row mb-4">
        <div className="col-12">
          <h1 className="h3 font-weight-bold text-dark mb-1">
            <i className="fa-solid fa-house mr-2 text-primary" />
            Welcome to KitchenOS
          </h1>
          <p className="text-muted mb-0">
            Signed in as <strong>{user?.email}</strong> &middot; Roles:{' '}
            <span className="badge badge-light border px-2 py-1 text-dark" data-testid="user-roles">
              {roles.length ? roles.join(', ') : 'none'}
            </span>
          </p>
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="font-weight-bold text-teal mb-3">
            <i className="fa-solid fa-bars mr-2" />Quick Navigation
          </h5>
          <div className="row">
            {MENU_TREE.map((item) => (
              <div key={item.pageId || item.label} className="col-md-4 mb-3">
                <Link
                  to={item.route || '#'}
                  className="btn btn-outline-primary btn-block py-3 text-left"
                  data-testid={`quicknav-${item.pageId}`}
                >
                  {item.icon && <i className={`${item.icon} mr-2`} />}
                  {item.label}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
